import React, { useState, useEffect, useRef } from 'react'
import PageHeader from '@/components/pageHeader'
import { useTranslation } from 'react-i18next'
import { Row, Col, Spin } from 'antd'
import ProjectList from './components/projectList'
import PrimeTable from '@/components/primeTable'
import QueryForm from './components/queryForm'
import { queryProject, queryProjectDetail } from '@/api/export'
import { queryDomain } from '@/api/dictionary'
import DebounceSearch from '@/components/debounceSearch'
import styles from './index.module.less'
import { exportTypes } from './constant'

const ExportRecord = () => {
  const { t } = useTranslation()
  const [queryParams, setQueryParams] = useState({})
  const [domains, setDomains] = useState<any[]>([])
  const [projects, setProjects] = useState([])
  const [activeProject, setActiveProject] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const projectsRef = useRef(null)
  const queryRef = useRef<any>(null)
  const columns = [
    {
      title: t('dict.dictType'),
      dataIndex: 'dictType',
    },
    {
      title: t('dict.dictName'),
      dataIndex: 'dictName',
    },
    {
      title: t('dict.dictVersion'),
      dataIndex: 'version',
    },
    {
      title: t('dict.publishTime'),
      dataIndex: 'publishTime',
    },
    {
      title: t('dict.directoryInfo'),
      dataIndex: 'directoryInfo',
    },
    {
      title: t('dict.itemInfo'),
      dataIndex: 'itemInfo',
    },
    {
      title: t('dict.createTime'),
      dataIndex: 'createTime',
    },
    {
      title: t('dict.operator'),
      dataIndex: 'exportBy',
    },
    {
      title: t('dict.exportType'),
      dataIndex: 'type',
      render(_, record){
        return (<span>{exportTypes[`${record.type}`]}</span>)
      }
    },
    
  ]
  const fetchProjects = async () => {
    setLoading(true)
    const res: any = await queryProject({
      type: 2,
    })
    setProjects(res)
    setLoading(false)
    if (res.length) {
      setActiveProject(res[0])
    }
    projectsRef.current = res
  }

  const fetchDomains = async () => {
    const res: any = await queryDomain({
      type: 1,
    })
    setDomains(
      res.map((item: any) => ({
        label: item.domainName,
        value: item.domainName,
      }))
    )
  }

  useEffect(() => {
    fetchProjects()
    fetchDomains()
  }, [])
  return (
    <>
      <PageHeader title={t('export.title')} />
      <Row wrap={false} gutter={24}>
        <Col flex="240px">
          <div className={styles.projectList}>
            <DebounceSearch
              onSearch={(val: any) => {
                if (!val) {
                  setProjects(projectsRef.current as any)
                  return
                }
                const filterProjects = (projectsRef.current as any).filter(
                  (item: any) => {
                    const trimValue = val.trim()
                    return (
                      item?.projectName?.includes(trimValue) ||
                      item?.projectCode?.includes(trimValue)
                    )
                  }
                )
                setProjects(filterProjects)
              }}
              placeholder={t('export.searchProject')}
            />
            <Spin spinning={loading} style={{ minHeight: 300 }}>
              <ProjectList
                data={projects}
                onSelect={(item: any) => {
                  setActiveProject(item)
                }}
                activeItem={activeProject}
              />
            </Spin>
          </div>
        </Col>
        <Col flex={1}>
          <QueryForm
            onQuery={setQueryParams}
            domainOptions={domains}
            ref={queryRef}
          />
          <PrimeTable
            columns={columns}
            request={queryProjectDetail}
            queryParams={{
              projectCode: activeProject.projectCode,
              ...queryParams,
            }}
            allowFetch={!!activeProject.projectCode}
            indexColumn
          />
        </Col>
      </Row>
    </>
  )
}

export default ExportRecord
